import { Box, Text, Select, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useState, useId } from 'react';

interface TabItem {
    tabLabel: string;
    tabContent: React.ReactNode;
}

interface TabsComponentProps {
    selectLabel: string;
    tabs: TabItem[];
}

const TabsComponentDato = ({ selectLabel, tabs }: TabsComponentProps) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const uniqueId = useId();
    const tabsSelectId = `tabs-select-${uniqueId}`;

    return (
        <Tabs variant="unstyled" index={selectedTab} onChange={index => setSelectedTab(index)}>
            <Box display={{ base: 'block', md: 'none' }}>
                <Text
                    as={'label'}
                    htmlFor={tabsSelectId}
                    fontSize={'12px'}
                    marginBottom={'5px'}
                    display={'block'}
                >
                    {selectLabel}
                </Text>
                <Select
                    id={tabsSelectId}
                    value={selectedTab}
                    onChange={e => setSelectedTab(Number(e.target.value))}
                    borderRadius="none"
                    borderWidth="0"
                    outlineColor="gray.400"
                    outlineOffset="0"
                    _placeholder={{ color: 'gray.400' }}
                    _focusVisible={{
                        outlineWidth: '2px',
                        outlineStyle: 'solid',
                        outlineColor: 'gray.800',
                        borderColor: 'gray.800',
                        boxShadow: 'none',
                    }}
                    sx={{
                        '& option': {
                            background: 'gray.400',
                            color: 'gray.0',
                        },
                    }}
                >
                    {tabs.map((tab, index) => (
                        <option key={index} value={index}>
                            {tab.tabLabel}
                        </option>
                    ))}
                </Select>
            </Box>
            <TabList justifyContent={'center'} display={{ base: 'none', md: 'flex' }}>
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        fontSize={'18px'}
                        padding={'20px'}
                        fontWeight={'normal'}
                        borderBottom={'3px solid'}
                        borderColor={'gray.100'}
                        _selected={{
                            fontWeight: 'bold',
                            color: 'gray.800',
                            borderColor: 'green.400',
                        }}
                    >
                        {tab.tabLabel}
                    </Tab>
                ))}
            </TabList>
            <TabPanels marginTop={{ base: '20px', lg: '50px' }}>
                {tabs.map((tab, index) => (
                    <TabPanel key={index} padding={0}>
                        {tab.tabContent}
                    </TabPanel>
                ))}
            </TabPanels>
        </Tabs>
    );
};

export default TabsComponentDato;
